import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/Logos/m-logo.svg";
import text from "../../Assets/Logos/logo-text.svg";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { PiUserCircleDuotone } from "react-icons/pi";
import "./AuthNavbar.css";

const AuthNavbar = ({ setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userProfilePic, setUserProfilePic] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("mankia-adminData"));
    if (storedData?.profilePic) {
      setUserProfilePic(storedData.profilePic);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("manika-token");
    localStorage.removeItem("mankia-adminData");
    navigate("/");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleLogoClick = () => {
    if (window.innerWidth < 1024) {
      setIsSidebarOpen((prevState) => !prevState);
    }
  };

  return (
    <nav className="bg-[#FFFFFF] shadow-lg fixed top-0  w-full p-3 text-[black] z-50">
      <div className="px-3 mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <div className="mr-4 h-8 translate-x-[40%] flex items-center gap-x-2 lg:translate-x-0 transition-all ease-in-out">
            <img
              src={logo}
              alt="Logo"
              className="w-auto h-full cursor-pointer"
              onClick={handleLogoClick}
            />
            <img
              src={text}
              alt="Logo"
              className="w-auto h-full  cursor-pointer"
              onClick={handleLogoClick}
            />
          </div>
        </div>

        <div className="flex items-center relative" ref={dropdownRef}>
          <button
            id="dropdownDefaultButton"
            onClick={toggleDropdown}
            className="flex items-center"
            type="button"
          >
            {userProfilePic ? (
              <img
                src={userProfilePic}
                alt="User Avatar"
                className="w-12 h-12 rounded-full object-cover border-2 border-primaryColor"
              />
            ) : (
              <PiUserCircleDuotone
                size={48}
                className="text-primaryColor border-2 border-primaryColor rounded-full p-[2px]"
              />
            )}
            <svg
              className={`w-3 h-3 ms-1 transform ${isDropdownOpen ? "rotate-180" : ""
                }`}
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>

          {isDropdownOpen && (
            <div className="z-10 absolute mt-[150px] ml-[-100px] bg-white divide-y divide-primaryColor rounded-lg shadow w-44">
              <ul className="py-2 text-sm text-primaryTextColor">
                <li>
                  <Link
                    to="/profile"
                    onClick={toggleDropdown}
                    className="cursor-pointer flex items-center px-4 py-2 hover:bg-primaryFadedColor hover:text-white hover:font-semibold tracking-wider text-center"
                  >
                    <FaUserCircle className="mr-2" size={16} />
                    Profile
                  </Link>
                </li>
                <li>
                  <div
                    onClick={() => {
                      handleLogout();
                      toggleDropdown();
                    }}
                    className="cursor-pointer flex items-center px-4 py-2 hover:bg-primaryFadedColor hover:text-white hover:font-semibold tracking-wider text-center"
                  >
                    <FaSignOutAlt className="mr-2" size={16} />
                    Sign out
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AuthNavbar;
